module.exports = __webpack_public_path__ + "img/formazione.abe7d806.jpeg";